import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Report } from 'src/app/models';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styles: [``],
})
export class ReportsComponent implements OnInit {
  public filterValue$: Observable<string>;
  public gridData$: Observable<GridDataResult>;
  public loaded$: Observable<boolean>;
  public pageSize = 40;
  public rowHeight = 30;
  public skip$ = new BehaviorSubject<number>(0);
  public sort$ = new BehaviorSubject<SortDescriptor[]>([
    {
      field: 'name',
      dir: 'asc',
    },
  ]);
  constructor(public dialog: MatDialog, private reportsService: ReportsService) {}

  ngOnInit() {
    this.loaded$ = this.reportsService.loaded$;
    this.filterValue$ = this.reportsService.filter$;
    this.reportsService.getAll().subscribe();

    this.gridData$ = combineLatest(this.reportsService.filteredEntities$, this.sort$, this.skip$).pipe(
      map(([reports, [sort], skip]) => {
        const data = sort.dir === 'asc' ? _.sortBy(reports, sort.field) : _.sortBy(reports, sort.field).reverse();

        const pagedData = data.slice(skip, skip + this.pageSize);
        return { data: pagedData, total: data.length };
      }),
    );
  }

  openNewDialog() {
    this.reportsService.openNewDialog().subscribe();
  }
  openEditDialog(report: Report) {
    this.reportsService.openEditDialog(report).subscribe();
  }

  delete(report: Report) {
    this.reportsService.delete(report);
  }
  filterReports(filter) {
    this.reportsService.setFilter(filter);
  }
  public sortChange(sort: SortDescriptor[]) {
    this.sort$.next(sort);
  }

  public pageChange(event: PageChangeEvent) {
    this.skip$.next(event.skip);
  }
}
